// Short two-tone "new message" beep generated with the Web Audio API (no audio file needed).
// Browsers only allow audio after a user gesture, so the context is unlocked on the first click/keypress.

let audioContext = null;

const getContext = () => {
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) return null;
  if (!audioContext) audioContext = new AudioCtx();
  return audioContext;
};

const unlock = () => {
  const ctx = getContext();
  if (ctx && ctx.state === "suspended") ctx.resume().catch(() => {});
};
["pointerdown", "keydown"].forEach((event) =>
  window.addEventListener(event, unlock, { once: true, capture: true })
);

export const playMessageBeep = () => {
  const ctx = getContext();
  if (!ctx || ctx.state !== "running") return;
  const start = ctx.currentTime;
  [
    { frequency: 880, at: 0 },
    { frequency: 1320, at: 0.11 },
  ].forEach(({ frequency, at }) => {
    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();
    oscillator.type = "sine";
    oscillator.frequency.value = frequency;
    gain.gain.setValueAtTime(0.0001, start + at);
    gain.gain.exponentialRampToValueAtTime(0.18, start + at + 0.015);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + at + 0.16);
    oscillator.connect(gain).connect(ctx.destination);
    oscillator.start(start + at);
    oscillator.stop(start + at + 0.17);
  });
};
